import CustomPopover from '../../../../components/CustomPopover/CustomPopover';
import useWatchList from './useWatchList';
import WatchListContent from './WatchListContent';

function WatchListDropdown() {
  const { watchListData, filteredItems } = useWatchList();

  return (
    <CustomPopover
      tooltip="Watch List"
      content={<WatchListContent data={watchListData} />}
      imageSrc="/watchTower.svg"
      badge={filteredItems?.length}
    />
  );
}

export default WatchListDropdown;
